import { npcs } from '../data/guide/npcs'
import { shops } from '../data/guide/shops'
import type { LocationPoint, NpcLocation } from './npcLocation'
import type { Npc } from '../types/progression'
import type { NpcServiceKind, Shop, ShopItem } from '../types/shop'
import type { WorldData } from '../types/world'

export const NPC_PATH = '/guia/npc'
export const npcShopPath = (npcId: string) => `${NPC_PATH}#${npcId}`

export const serviceLabel: Record<NpcServiceKind, string> = {
  venta: 'Venta',
  reparacion: 'Reparación',
  mejoras: 'Mejoras',
  misiones: 'Misiones',
  combinaciones: 'Combinaciones',
  acceso: 'Acceso a mapa',
  otros: 'Otros',
}

/** Puntos de ubicación de cualquier estado (configuración, administración o referencia). */
export function locationPoints(loc: NpcLocation | undefined): LocationPoint[] {
  if (!loc) return []
  if (loc.state === 'config' || loc.state === 'admin') return loc.points
  if (loc.state === 'reference') return loc.reference.points
  if ((loc.state === 'loading' || loc.state === 'error') && loc.reference) return loc.reference.points
  return []
}

/** Orden de mapas: primero Lorencia y Noria, luego el resto por nombre, y al final sin ubicación. */
const FIRST = ['Lorencia', 'Noria']
export const UNLOCATED = 'Sin ubicación documentada'
export function compareMapGroups(a: string, b: string): number {
  const ia = FIRST.indexOf(a)
  const ib = FIRST.indexOf(b)
  if (ia !== -1 || ib !== -1) return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib)
  if (a === UNLOCATED) return 1
  if (b === UNLOCATED) return -1
  return a.localeCompare(b)
}

export const shopOf = (npcId: string): Shop | undefined => shops.find((s) => s.npcId === npcId)

/** Productos cuyo ítem o variante sigue publicado (respeta las exclusiones aplicadas al catálogo). */
export function publishedShopItems(w: WorldData | undefined, shop: Shop): ShopItem[] {
  if (!w) return shop.items
  return shop.items.filter((it) => w.items.has(it.itemId) || w.variants.has(it.itemId))
}

/** Ventas documentadas de un ítem: incluye sus variantes (14,11 → 14,11@8). */
export function sellersOf(itemId: string): { npc: Npc; shop: Shop; item: ShopItem }[] {
  const out: { npc: Npc; shop: Shop; item: ShopItem }[] = []
  shops.forEach((shop) => {
    const npc = npcs.find((n) => n.id === shop.npcId)
    if (!npc) return
    shop.items.forEach((item) => {
      if (item.itemId === itemId || item.itemId.split('@')[0] === itemId || itemId.split('@')[0] === item.itemId) out.push({ npc, shop, item })
    })
  })
  return out
}

export const priceLabel = (it: ShopItem) => (it.price !== undefined && it.currency ? `${it.price.toLocaleString('es-ES')} ${it.currency}` : undefined)
